<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
        :title="'CADASTRO DE PARÂMETROS SERASA'"
        showClearButton
        showSaveButton
        @Clear="onClear"
        @Save="onSave"
      >
      <div class="form-group row">
        <div class="col-md-6 pb-3">
          <label for="usuarioInput"><small v-if="form.usuario.required" class="text-danger">*</small> Usuário:</label>
          <div class="input-group">
            <b-form-input type="text" id="usuarioInput" name="usuarioInput" v-model="form.usuario.value"
              :maxlength="form.usuario.maxlength" :required="form.usuario.required" :state="form.usuario.state" />
          </div>
        </div>
        <div class="col-md-6">
          <label for="senhaInput"><small v-if="form.senha.required" class="text-danger">*</small> Senha:</label>
          <div class="input-group">
            <b-form-input type="password" id="senhaInput" name="senhaInput" v-model="form.senha.value"
              :maxlength="form.senha.maxlength" :required="form.senha.required" :state="form.senha.state" />
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtGroup">
            <small v-if="form.eventoId.required" class="text-danger">*</small>
            Follow-up Padrão:
          </label>
          <div class="input-group">
            <b-form-select v-model="form.eventoId.value" :options="form.eventoId.options" :state="form.eventoId.state" class="mb-3">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <label for="urlBaseInput"><small v-if="form.urlBase.required" class="text-danger">*</small> URL base:</label>
          <div class="input-group">
            <b-form-input type="text" id="urlBaseInput" name="urlBaseInput" v-model="form.urlBase.value"
                          :maxlength="form.urlBase.maxlength" :required="form.urlBase.required" :state="form.urlBase.state" />
          </div>
        </div>
        <div class="pt-3 col-md-12">
          <label class="pb-3">Tipos da Integração:</label>
          <div class="ml-2 input-group row">
            <div class="col-2 pb-2">
              <b-form-checkbox @change="isNotCheked(form.informacoesCadastrais.value)" v-model="form.informacoesCadastrais.value" switch :value="true" :unchecked-value="false">
                Consulta Básica
              </b-form-checkbox>
              <i
                class="fa fa-info-circle"
                style="font-size: 14px;"
                v-b-popover.hover="{
                      title: 'Consulta Serasa base possui:',
                      content: ['Informações cadastrais',' Cheque sem Fundo', ' Protestos', ' Pendências de Pagamento'],
                      variant: 'light',
                      html: true
                    }"
              />
            </div>
            <div class="col-2 pb-2">
              <b-form-checkbox @change="isChecked(form.renda.value)" v-model="form.renda.value" switch :value="true" :unchecked-value="false">
              Renda
            </b-form-checkbox>
            </div>
            <div class="col-2 pb-2">
              <b-form-checkbox @change="isChecked(form.score.value)" v-model="form.score.value" switch :value="true" :unchecked-value="false">
              Score
            </b-form-checkbox>
            </div>
            <div class="col-2 pb-2">
              <b-form-checkbox @change="isChecked(form.socios.value)" v-model="form.socios.value" switch :value="true" :unchecked-value="false">
                Sócios
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>

<script>
import EventRepository from '@/shared/http/repositories/configurations/event.js'
import SerasaRepository from '@/shared/http/repositories/configurations/serasa.js'

import ActionsForm from '@/shared/mixins/actionsForm'
import serasaForm from './serasa-form'
import { toast, loading } from '@/shared/utils/UIHelper'

const serasaData = {
  id: 123,
  usuario: null,
  senha: null,
  eventoId: null,
  urlBase: null,
  informacoesCadastrais: false,
  renda: false,
  score: false,
  socios: false
}

export default {
  name: 'SerasaParams',
  mixins: [ActionsForm],
  data () {
    return {
      form: serasaForm,
      data: serasaData
    }
  },
  methods: {
    async onLoad () {
      this.onLoadAllEventType()
      try {
        const response = await SerasaRepository.GetParams()
        if (response.status === 200) {
          this.onEdit(response.data)
          this.form.eventoId.value = response.data.eventoEntity ? response.data.eventoEntity.id : null
        }
      } catch (error) {
        console.error(error)
        this.onException(error)
      }
    },
    onCreate () {
      toast.error('Parâmetro não possui registro', 'Erro ao salvar dados')
    },
    async onUpdate () {
      try {
        console.log(this.data)
        const response = await SerasaRepository.UpdateParams(this.data)
        if (response.status === 200) {
          toast.success(this.$lang.Common.Alerts.Success)
        }
      } catch (error) {
        console.error(error)
        this.onException(error)
      } finally {
        loading.pop()
      }
    },
    onLoadAllEventType () {
      loading.push()
      this.form.eventoId.options = []
      EventRepository.GetAllActive(null, this.isVisita)
        .then((response) => {
          if (response.status === 200) {
            let data = response.data.content
            if (data) {
              this.events = []
              data.forEach(x => {
                if (x.tipoEventoDTO.nome !== 'CRM') {
                  this.events.push({
                    'id': x.id,
                    'nome': x.nome,
                    'tipo': x.tipoEventoDTO.nome,
                    'deslocamento': x.deslocamento,
                    'despesa': x.despesa,
                    'mnemonic': x.mnemonic
                  })
                }
              })

              this.events.sort((a, b) => {
                let typeA = a.tipo.toLowerCase()
                let typeB = b.tipo.toLowerCase()
                if (typeA < typeB) {
                  return -1
                }
                if (typeA > typeB) {
                  return 1
                }
                return 0
              })

              let opt = []
              this.events.forEach(x => {
                if (!opt.find(opt => opt.label === x.tipo)) {
                  let options = []
                  this.events.forEach(y => {
                    if (y.tipo === x.tipo) {
                      options.push({ value: y.id, text: y.nome, mnemonic: y.mnemonic })
                    }
                  })
                  opt.push({
                    label: x.tipo,
                    options: options
                  })
                  options = []
                }
              })
              this.form.eventoId.options = opt
            }
          }
        })
        .catch((err) => {
          this.onException(err)
        })
        .finally(() => {
          loading.pop()
        })
    },
    isChecked (value) {
      if (value) {
        this.form.informacoesCadastrais.value = true
        toast.warning('ATENÇÃO! Esse recurso gera custo adicional na consulta Serasa.')
      }
    },
    isNotCheked (value) {
      if (!value) {
        this.form.renda.value = false
        this.form.score.value = false
        this.form.socios.value = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros/SerasaParams/SerasaParams.vue